import { create } from "zustand";
import axios from "axios";
import { useAppLoading } from "./useAppLoading";
import { LOG } from "../utils/logUtil";

export interface IMaterialFeedback {
  _id?: string;
  user?: string;
  userName?: string | null;
  preRegisteredDrop?: {
    _id?: string;
    barcode?: string;
    location?: string;
    machineId?: string;
  };
  selectedMaterial?: string | null;
  userRejected?: boolean;
  aiKeywords?: Array<{ label: string; value: number }>;
  createdAt?: string;
}

interface IStore {
  feedback: IMaterialFeedback[];
  hasNextPage: boolean;
  total: number;
  getFeedback: (
    page: number,
    limit: number,
    params?: { userId?: string; userName?: string }
  ) => void;
  clearFeedback: () => void;
}

export const useMaterialFeedback = create<IStore>()((set) => ({
  feedback: [],
  hasNextPage: false,
  total: 0,
  getFeedback: async (
    page: number,
    limit: number,
    params?: { userId?: string; userName?: string }
  ) => {
    useAppLoading.getState().setIsLoading(true);
    try {
      const searchParams = new URLSearchParams({
        page: String(page),
        limit: String(limit),
      });
      if (params?.userId) {
        searchParams.append("userId", params.userId);
      }
      if (params?.userName) {
        searchParams.append("userName", params.userName);
      }

      const response = await axios.get(
        `/beevision-drops/material-selection-feedback?${searchParams.toString()}`
      );
      const data = response?.data;

      set((state) => ({
        feedback:
          page === 1
            ? (data?.items ?? [])
            : [...state.feedback, ...(data?.items ?? [])],
        hasNextPage: page < (data?.totalPages ?? 0),
        total: data?.total ?? 0,
      }));
    } catch (error) {
      LOG.error("Error fetching material selection feedback", { error });
    } finally {
      useAppLoading.getState().setIsLoading(false);
    }
  },
  clearFeedback: () =>
    set({
      feedback: [],
      hasNextPage: false,
      total: 0,
    }),
}));
